// /src/toolkitServices/branchApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const branchApi = createApi({
  reducerPath: "branchApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),

  tagTypes: ["Branch"],
  endpoints: (builder) => ({
    addBranch: builder.mutation({
      query: (newBranch) => ({
        url: "/branches/create",
        method: "POST",
        body: newBranch,
      }),
      invalidatesTags: ["Branch"],
    }),

    // ⬇️ company + active params support
    getAllBranches: builder.query({
      query: ({ page = 1, limit = 10, search = "", company, active } = {}) => {
        const params = { page, limit, q: search };
        if (company) params.company = company; // id or name
        if (typeof active === "boolean") params.active = active; // true/false
        return { url: "/branches", params };
      },
      providesTags: ["Branch"],
    }),
    getAllBranchesAll: builder.query({
      query: ({ page = 1, limit = 10, search = "", company, active } = {}) => {
        const params = { page, limit, q: search };
        if (company) params.company = company; // id or name
        if (typeof active === "boolean") params.active = active; // true/false
        return { url: "/branches/all", params };
      },
      providesTags: ["Branch"],
    }),

    getBranchById: builder.query({
      query: (id) => `/branches/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Branch", id }],
    }),

    updateBranch: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/branches/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Branch"],
    }),

    deleteBranch: builder.mutation({
      query: (id) => ({
        url: `/branches/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Branch"],
    }),

    // already used in your list
    activateBranch: builder.mutation({
      query: (id) => ({
        url: `/branches/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Branch"],
    }),
    deactivateBranch: builder.mutation({
      query: (id) => ({
        url: `/branches/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Branch"],
    }),
  }),
});

export const {
  useAddBranchMutation,
  useGetAllBranchesQuery,
  useGetAllBranchesAllQuery, // ✅ NEW HOOK

  useGetBranchByIdQuery,
  useUpdateBranchMutation,
  useDeleteBranchMutation,
  useActivateBranchMutation,
  useDeactivateBranchMutation,
} = branchApi;

export default branchApi;
